//@flow
import * as Immutable from 'immutable';

import {
    Carriers,
    Carrier
} from 'platform/settings/modules/orchestration/models/flow/Carriers';
import type {
    CarriersModelType,
    CarrierModelType
} from 'platform/settings/modules/orchestration/models/flow/Carriers';

class InternalCarriers extends Carriers {
    static fromJS(json: CarriersModelType): InternalCarriers {
        const state: Object = Object.assign({}, json);
        state.carriers = Immutable.List(state.carriers).map(item =>
            InternalCarrier.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }
}

class InternalCarrier extends Carrier {
    static fromJS(json: CarrierModelType): InternalCarrier {
        const state: Object = Object.assign({}, json);
        state.serviceTypes = Immutable.List(state.serviceTypes);
        return new this(Immutable.Map(state));
    }
}

export { InternalCarriers as Carriers, InternalCarrier as Carrier };
